import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import ClassifiedinformationForm from "./ClassifiedinformationForm";
import { updateClassifiedInformation } from "common/services/persons.service";
import { useDispatch } from "react-redux";
import { getPerson as onGetPerson } from "slices/thunks";

const UpdateClassifiedInformation: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  person: any;
}> = ({ toggle, isModalOpen, person }) => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const data = person?.classifiedInformation || [];

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      classifiedInformation: (data.length > 0 &&
        data.map((classifiedInformation: any) => {
          return {
            id: classifiedInformation?.id,
            classifiedInformationType: {
              value: classifiedInformation?.type?.id,
              label: classifiedInformation?.type?.name,
            },
            description: classifiedInformation?.description,
            reportingAgency: {
              value: classifiedInformation?.reportingAgency?.id,
              label: classifiedInformation?.reportingAgency?.name,
            },
            date:
              (classifiedInformation?.date &&
                new Date(classifiedInformation.date)) ||
              null,
          };
        })) || [
        {
          classifiedInformationType: {
            value: "",
            label: "",
          },
          description: "",
          reportingAgency: {
            value: "",
            label: "",
          },
          date: null,
        },
      ],
    },
    validationSchema: Yup.object({
      classifiedInformation: Yup.array().of(
        Yup.object({
          classifiedInformationType: Yup.object().shape({
            value: Yup.number().required(
              "Please select classified information type"
            ),
          }),
          description: Yup.string(),
          reportingAgency: Yup.object().shape({
            value: Yup.number().required("Please select reporting agency"),
          }),
          date: Yup.date().required("Please select date"),
        })
      ),
    }),
    onSubmit: (values: any) => {
      const data = {
        id: person.id,
        data: values.classifiedInformation.map((classifiedInformation: any) => {
          return {
            id: classifiedInformation.id || null,
            type: classifiedInformation.classifiedInformationType.value || null,
            description: classifiedInformation.description,
            reportingAgency:
              classifiedInformation.reportingAgency.value || null,
            date:
              classifiedInformation.date &&
              classifiedInformation.date?.toLocaleDateString("en-CA"),
          };
        }),
      };

      setLoading(true);
      const saveData = async () => {
        try {
          await updateClassifiedInformation(person.id, data);
          validation.resetForm();
          toggle();
          toast.success("Classified Information Updated Successfully", {
            autoClose: 1000,
          });
        } catch (err: any) {
          toast.error("Error while updating classified information", {
            autoClose: 1000,
          });
        } finally {
          setLoading(false);
          dispatch(
            onGetPerson({
              id: person.id,
            })
          );
        }
      };
      saveData();
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Classified Information
        <small
          color="light"
          className="badge bg-primary-subtle align-bottom ms-1 text-primary"
        >
          {validation?.values?.classifiedInformation?.length || 0}
        </small>
      </ModalHeader>

      <ClassifiedinformationForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
        setLoading={setLoading}
      />
    </Modal>
  );
};

export default UpdateClassifiedInformation;
